import { DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, PaginationProps, Select, Switch } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import * as typeVehicleApi from '../../../api/typeVehicle/typeVehicleApi';
import { getListTypeVehicle, ITypeVehicle, updateActiveTypeVehicle } from '../../../api/typeVehicle/typeVehicleApi';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { API_URL } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import { checkDisabledPermission, dataPagination, fommatSelectOption, getUserPermissions } from '../../../until';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import ModalCreateCatecoryCar from './Component/Modal/ModalCreateCatecoryCar';
import ModalEditCatecoryCar from './Component/Modal/ModalEditCategoryCar';
import ModalViewCategoryCar from './Component/Modal/ModalViewCategoryCar';
import './style.scss';
import { getCLCarLines } from '../../../api/selectOption/selectOptionsApi';
import { ISelectOption } from '../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from '../../../components/NoDataTable';
import { formatNumber } from '../../../services/mixin';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { activeArray } from '../../../api/unit/unitApi';

interface IDataDefaulFilterList {
  search: string;
  carLineId?: number;
}
const dataDefaulFilterList: IDataDefaulFilterList = {
  search: "" as string, // Thêm trường search
  carLineId: undefined
};

const VehicleCategory_V2: React.FC = () => {
  useEffect(() => {
    gCLCarLine()

    return (() => {
      setDataFilterList(dataDefaulFilterList)
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])
    })
  }, [])

  const location = useLocation();
  const pushToast = useToast();
  const pushLoading = useLoading()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false)
  const [isOpenModalView, setIsOpenModalView] = useState(false)
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false)
  const [isModalDelete, setIsModalDelete] = useState(false)

  const [openModalUpload, setOpenModalUpload] = useState(false);

  // bộ lọc
  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])

  const [fileData, setFileData] = useState({} as any)

  const [type, setType] = useState<string>("")

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [idChose, setIdChose] = useState<number>();

  const [infoTypeVehicle, setInfoTypeVehicle] = useState<ITypeVehicle>()

  const [listTypeVehicle, setListTypeVehicle] = useState<ITypeVehicle[]>([])

  const hasSelected = selectedRowKeys.length > 0;

  const actionColumn: ColDef = {
    headerName: 'Hành động',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      const id = params.data.id
      return (
        <div className='d-flex gap-4 justify-center align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoCarLine(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoCarLine(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
            onClick={() => openModalDelete(Number(id))}
          />

        </div>

      )
    },
  }

  const columnDefs = useMemo<ColDef<ITypeVehicle>[]>(() =>
    [
      actionColumn,
      {
        headerName: "Dòng xe",
        field: "carLineTitle",
        flex: 1
      },
      {
        headerName: "Mã loại xe",
        field: "code",
        flex: 1
      },
      {
        headerName: "Loại xe",
        field: "title",
        flex: 1
      },
      {
        headerName: "Trạng thái",
        field: "status",
        cellRenderer: (params: ICellRendererParams) => {
          const { id, status } = params.data;
          return (
            <div className="d-flex align-center gap-10-px">
              <Switch
                defaultChecked={!!status}
                onChange={() => uActiveTypeVehicle(Number(id))}
                className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
              />
              <p className="font-medium fw-500 text-344054">
                {activeArray[status ? 1 : 0]}
              </p>
            </div>
          );
        },
        flex: 1
      },
    ], [pagination]);

  const gCLCarLine = useDebounce(async () => {
    pushLoading(true)
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gListTypeVehicle = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const { carLineId, search } = dataFilterList

    const result = await getListTypeVehicle(
      pageSize, pageCurent, carLineId, search
    )
    if (result?.status) {
      setListTypeVehicle(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gInfoCarLine = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await typeVehicleApi.getInfoTypeVehicle(
      id
    )
    if (result?.status) {
      setInfoTypeVehicle(result.data)
      if (isview)
        setIsOpenModalView(true)
      else
        setIsOpenModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const uActiveTypeVehicle = useThrottle(async (id: number, isActive: boolean) => {
    pushLoading(true)
    const result = await updateActiveTypeVehicle(
      id
    )
    if (result?.status) {
      gListTypeVehicle(pagination.current, pagination.pageSize)
      pushToast(result?.message, "success")
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalAdd(false)
      pushToast(message, "success")
      gListTypeVehicle(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalEdit(false)
      pushToast(message, "success")
      gListTypeVehicle(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalDelete = async () => {
    if (!idChose) return
    const result = await typeVehicleApi.deleteTypeVehicle(idChose)
    if (result.status) {
      setIsModalDelete(false)
      pushToast(result.message, "success")
      gListTypeVehicle(pagination.current, pagination.pageSize)
    } else {
      pushToast(result.message, "error")
    }
  }

  const openModalDelete = (id: number) => {
    setIdChose(id)
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setIdChose(undefined)
    setIsModalDelete(false)
  }



  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListTypeVehicle(pageNumber, pageSize)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };


  const handleUpload = async (type: string): Promise<typeVehicleApi.ResponseSuccessDataError> => {
    pushLoading(true)
    setType(type)
    const result = await typeVehicleApi.uploadFileTypeVehicle(fileData)
    if (result?.status) {

    }
    pushLoading(false)
    return result
  }
  const handleFile = (file: any) => {
    setFileData(file)
  }

  useEffect(() => {
    gListTypeVehicle()
  }, [dataFilterList])


  return (
    <Fragment>
      <ModalCreateCatecoryCar
        isOpen={isOpenModalAdd}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenModalAdd(false)}
      />

      <ModalViewCategoryCar
        isOpen={isOpenModalView}
        infoTypeVehicle={infoTypeVehicle}
        closeModal={() => setIsOpenModalView(false)}
      />

      <ModalEditCatecoryCar
        isOpen={isOpenModalEdit}
        infoTypeVehicle={infoTypeVehicle}
        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenModalEdit(false)}
      />

      <ModalDeleteManager
        isOpen={isModalDelete}
        title="Bạn có chắc chắn xóa loại xe này không?"
        titleDelete="Xóa loại xe"
        content="Loại xe sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onSubmitFormModalDelete}
      />
      <ImportDataColorCar
        show={openModalUpload}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/car/Danhsachthuonghieu.xlsx`}
        type={"dataCategoryError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        // gListCarColor={gListCategoryCar}
        modalClose={() => setOpenModalUpload(false)}
      />
      <Layout className='customer-list'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Quản lý danh mục xe', },
            { title: 'Quản lý loại xe', },
          ]}
          title='Quản lý loại xe'
          className='gutter-block-end'
        />

        {/* Fillter block */}
        <div className={`filter-block ${hasSelected ? "active" : ""}`}>


          <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
            <Input
              placeholder="Tìm kiếm thông tin loại xe"
              className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
              value={dataFilterList.search}
              onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
            />
            <div className=" border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div>
          <div className='d-flex align-center gap-2'>
            <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
              <div className="d-flex align-center  w-full">
                <Select
                  showSearch
                  allowClear
                  className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                  popupClassName='position-dropdow custome-select-item h-popUp'
                  variant="borderless"
                  placeholder="Chọn dòng xe"
                  suffixIcon={null}
                  options={cLCarLines}
                  value={dataFilterList.carLineId}
                  onChange={(e) => setDataFilterList({ ...dataFilterList, carLineId: e })}
                />

              </div>
              <div className="  h-full d-flex align-center">
                <DownOutlined className="text-sm text-98A2B3 " />
              </div>
            </div>
          </div>
          <div
            className={`btn-input ${checkDisabledPermission(download)}`}
          // onClick={glistByExcel}
          >
            <div className="icon-svg">
              <DownloadOutlined />
            </div>
            <div className="text">Xuất DS</div>
          </div>

          <button
            className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(upload)}`}
            onClick={() => setOpenModalUpload(true)}
          >
            <UploadOutlined className='text-sm text-344054' />
            <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
          </button>
          <div
            className={`btn-input btn-primary  ${checkDisabledPermission(add)}`}
            onClick={() => setIsOpenModalAdd(true)}
          >
            <div className="icon-svg">
              <PlusOutlined />
            </div>
            <div className="text">Tạo mới</div>
          </div>

          {/* <div className="btn-input t-px-8" onClick={() => setSettingShow(true)}>
            <div className="icon-svg">
              <SettingOutlined />
            </div>
          </div> */}
        </div>

        {/* Fillter block */}
        <div className={`filter-block filter-active-show ${hasSelected ? "active" : ""}`}>
          <div className='total-chosse'>
            {hasSelected ? `Đã chọn ${selectedRowKeys.length} loại xe` : ''}
          </div>

          <div className="btn-input">
            <div className="icon-svg">
              <img src="/customer/cm.svg" alt="" />
            </div>
            <div className="text">Gửi SMS</div>
          </div>

          <div className="btn-input">
            <div className="icon-svg">
              <img src="/customer/email.svg" alt="" />
            </div>
            <div className="text">Gửi Email</div>
          </div>

          <div className="btn-input">
            <div className="icon-svg">
              <img src="/customer/zalo.svg" alt="" />
            </div>
            <div className="text">Gửi ZNS</div>
          </div>

          <div
            className="btn-input"
          // onClick={() => setModalShow(true)}
          >
            <div className="icon-svg">
              <img src="/customer/use.svg" alt="" />
            </div>
            <div className="text">Nhóm khách hàng</div>
          </div>

          <div
            className="btn-input"
          // onClick={glistSelectedExel}
          >
            <div className="icon-svg">
              <img src="/customer/down.svg" alt="" />
            </div>
            <div className="text">Xuất DS </div>
          </div>
          <div
            className="btn-input"
          // onClick={() => openModalDeleteListCustomerMore(numericKeys)}
          >
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer `}

            />
            <div className="text">Xóa khách hàng</div>
          </div>
        </div>

        <div className={`order-history-card__body  custom-page-css flex flex-col flex-1 justify-between`}>
          <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={listTypeVehicle}
              columnDefs={columnDefs}
              rowHeight={55}
              rowSelection={{ mode: 'multiRow' }}
              overlayNoRowsTemplate={NodataTable}
              suppressDragLeaveHidesColumns={true}
            />

          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                className='rs-pagination'
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </Fragment>
  )
}

export default VehicleCategory_V2;
